// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--75535";
export var footer = "footer-module--footer--2b1a3";
export var linklist = "footer-module--linklist--e39c4";